import styled from 'styled-components'

export const Container = styled.div`
    margin-top: -2.5rem;
    margin-bottom: 2.5rem;
    display: flex;
    align-items: center;
    p {
        margin: 0;
        font-weight: 400;
        font-size: 0.75rem;
        line-height: 1rem;
        color: #666666;
    }
`
